
(function(){
  var THRESHOLD = 16;
  var COLOURS = [
    ['Red','#C8282D',['red','wine','burgundy','cerise','ruby','claret','maroon']],
    ['Pink','#E58FB0',['pink','blush','rose','fuchsia','magenta','peach']],
    ['Orange','#E57A2E',['orange','terracotta','rust','copper','ochre','coral']],
    ['Yellow','#F2C230',['yellow','mustard','lemon','sunflower']],
    ['Gold','#C9A24A',['gold','brass','champagne']],
    ['Green','#3F8F4E',['green','olive','sage','lime','emerald','mint','bottle','forest','khaki','camo']],
    ['Teal','#1E8C8A',['teal','turquoise','aqua','duck egg']],
    ['Blue','#2F63B8',['blue','navy','sky','denim','royal','cobalt']],
    ['Purple','#7B4FA6',['purple','lilac','lavender','mauve','plum','violet','aubergine']],
    ['Brown','#8A5A3B',['brown','chocolate','coffee','tan','mocha','taupe']],
    ['Beige','#D9C7A7',['beige','cream','ivory','natural','ecru','stone','sand','oatmeal']],
    ['Grey','#9A9A9A',['grey','gray','silver','charcoal']],
    ['Black','#1D1D1F',['black','jet']],
    ['White','#F4F4F2',['white']]
  ];
  function coloursOf(name){
    var n = ' ' + name.toLowerCase() + ' ', out = [];
    COLOURS.forEach(function(c){ if (c[2].some(function(w){ return n.indexOf(w) > -1; })) out.push(c); });
    return out;
  }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function money(c){ return '£' + (c / 100).toFixed(2); }
  var PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
  var stock = null, inBag = {};
  function stockOf(id){
    if (!stock) { stock = {}; try { stock = JSON.parse((document.getElementById('brf-v3-stock') || {}).textContent || '{}'); } catch (e) {} }
    var n = stock[String(id)]; return n == null ? null : n;
  }
  function loadBag(){
    return fetch('/cart.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}}).then(function(r){ return r.json(); }).then(function(c){
      inBag = {}; (c.items || []).forEach(function(it){ inBag[it.variant_id] = (inBag[it.variant_id] || 0) + it.quantity; });
    }).catch(function(){});
  }

  var product = null;
  try { product = JSON.parse(document.getElementById('brf-vp-product').textContent); } catch(e) {}
  if (!product || !product.variants) return;

  function init(){
    var options = document.querySelectorAll('.product-block-list__item--info .product-form__option, .product-form .product-form__option');
    [].forEach.call(options, function(opt){
      if (opt.__brfvp) return;
      var list = opt.querySelector('.block-swatch-list, .color-swatch-list, .variant-swatch-list');
      if (!list) return;
      var radios = [].slice.call(list.querySelectorAll('input[type="radio"]'));
      if (radios.length < THRESHOLD) return;
      opt.__brfvp = true;
      var pos = parseInt(radios[0].getAttribute('data-option-position'), 10) || 1;
      var optName = (opt.querySelector('.product-form__option-name') || {}).firstChild;
      optName = optName ? String(optName.textContent).replace(':','').trim() : 'Design';

      /* Build value data: first variant image, cheapest price, availability */
      var values = radios.map(function(r){
        var v = r.getAttribute('data-value') || r.value, vs = product.variants.filter(function(x){ return x['option' + pos] === v; });
        var img = null, avail = false, price = null, cmp = null;
        vs.forEach(function(x){
          if (!img && x.featured_image) img = x.featured_image.src;
          if (x.available) avail = true;
          if (price === null || x.price < price) { price = x.price; cmp = x.compare_at_price; }
        });
        return { value: v, input: r, img: img, avail: avail, price: price, cmp: cmp, colours: coloursOf(v) };
      });

      /* the variant a pick adds: this design + whatever is chosen in the product's other options */
      function form(){ return document.querySelector('.product-block-list__item--info form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]'); }
      function curVariant(){
        var f = form(), el = f && f.querySelector('[name="id"]'), id = el && parseInt(el.value, 10);
        return product.variants.filter(function(x){ return x.id === id; })[0] || product.variants[0];
      }
      function variantFor(val){
        var c = curVariant(), vs = product.variants.filter(function(x){ return x['option' + pos] === val.value; });
        var exact = vs.filter(function(x){ for (var k = 1; k <= 3; k++) { if (k !== pos && x['option' + k] !== c['option' + k]) return false; } return true; })[0];
        if (exact) return exact;
        return vs.filter(function(x){ return x.available; })[0] || vs[0];
      }
      function roomFor(v){ if (!v || !v.available) return 0; var m = stockOf(v.id); return Math.min(99, m == null ? 99 : Math.max(0, m - (inBag[v.id] || 0))); }

      list.style.display = 'none';
      var wrap = document.createElement('div');
      wrap.className = 'brf-vp';
      wrap.innerHTML = '<button type="button" class="brf-vp__current" aria-haspopup="dialog"><span class="brf-vp__thumb"></span><span class="brf-vp__meta"><small>Selected ' + esc(optName.toLowerCase()) + '</small><b></b></span><span class="brf-vp__change">Browse all ' + values.length + '</span></button><div class="brf-vp__strip" role="list"></div>';
      list.parentNode.insertBefore(wrap, list.nextSibling);
      var cur = wrap.querySelector('.brf-vp__current'), strip = wrap.querySelector('.brf-vp__strip');

      function thumbHtml(val, w){
        if (val.img) return '<img src="' + val.img + (val.img.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + '&height=' + w + '&crop=center" alt="" loading="lazy">';
        var cs = val.colours.map(function(c){ return c[1]; });
        if (!cs.length) cs = ['#E4DDD1', '#F6F3EE'];
        if (cs.length === 1) cs.push(cs[0]);
        return '<span class="brf-vps__sw" style="display:block;width:100%;height:100%;background:linear-gradient(135deg,' + cs.join(',') + ')"></span>';
      }
      function selected(){ var r = values.filter(function(x){ return x.input.checked; })[0]; return r || values[0]; }
      function choose(val){
        var label = document.querySelector('label[for="' + val.input.id + '"]');
        if (label) label.click(); else { val.input.checked = true; val.input.dispatchEvent(new Event('change', {bubbles:true})); }
        setTimeout(render, 30);
      }
      function render(){
        var s = selected();
        cur.querySelector('.brf-vp__thumb').innerHTML = thumbHtml(s, 120);
        cur.querySelector('b').textContent = s.value;
        /* quick-pick strip: selected first, then designs with photos */
        var picks = [s].concat(values.filter(function(x){ return x !== s && x.img && x.avail; })).slice(0, 10);
        strip.innerHTML = picks.map(function(x){ return '<button type="button" class="brf-vp__mini' + (x === s ? ' is-on' : '') + (x.avail ? '' : ' is-out') + '" title="' + esc(x.value) + '" data-v="' + esc(x.value) + '">' + thumbHtml(x, 100) + '</button>'; }).join('') + '<button type="button" class="brf-vp__more">+' + (values.length - picks.length) + ' more</button>';
      }
      strip.addEventListener('click', function(e){
        var b = e.target.closest('.brf-vp__mini');
        if (b) { var v = values.filter(function(x){ return x.value === b.getAttribute('data-v'); })[0]; if (v) choose(v); return; }
        if (e.target.closest('.brf-vp__more')) openSheet();
      });
      cur.addEventListener('click', openSheet);
      radios.forEach(function(r){ r.addEventListener('change', function(){ setTimeout(render, 30); }); });
      render();

      /* ---------- Sheet ---------- */
      var sheet = null, filt = { q: '', colour: null, stock: false }, picks = {};
      function openSheet(){
        if (!sheet) buildSheet();
        drawGrid(); drawTray();
        loadBag().then(function(){ clampPicks(); drawGrid(); drawTray(); });
        sheet.classList.add('is-open'); document.documentElement.classList.add('brf-vps-open','brf-md-open');
        setTimeout(function(){ var i = sheet.querySelector('input'); if (i && window.matchMedia('(min-width:750px)').matches) i.focus(); }, 60);
      }
      function closeSheet(){ sheet.classList.remove('is-open'); document.documentElement.classList.remove('brf-vps-open','brf-md-open'); cur.focus(); }
      function buildSheet(){
        var counts = {};
        values.forEach(function(v){ v.colours.forEach(function(c){ counts[c[0]] = (counts[c[0]] || 0) + 1; }); });
        var chips = COLOURS.filter(function(c){ return counts[c[0]] >= 2; }).map(function(c){
          return '<button type="button" class="brf-vps__chip" data-c="' + c[0] + '"><i style="background:' + c[1] + '"></i>' + c[0] + ' <span style="opacity:.6">' + counts[c[0]] + '</span></button>';
        }).join('');
        sheet = document.createElement('div');
        sheet.className = 'brf-vps';
        sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', 'Select ' + optName.toLowerCase());
        sheet.innerHTML = '<div class="brf-vps__scrim" data-x></div><div class="brf-vps__panel">'
          + '<div class="brf-vps__head"><p class="brf-vps__title">Select one ' + esc(optName.toLowerCase()) + ', or several at once<span>' + values.length + ' options · Tap one to select it, or use + to add several to your bag together</span></p><button type="button" class="brf-vps__x" data-x aria-label="Close">×</button></div>'
          + '<div class="brf-vps__tools"><label class="brf-vps__search"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg><input type="search" placeholder="Search designs, e.g. damask, stripe, floral" aria-label="Search ' + esc(optName) + '"></label>'
          + '<div class="brf-vps__chips"><button type="button" class="brf-vps__chip" data-stock>In stock only</button>' + chips + '</div></div>'
          + '<div class="brf-vps__body"><p class="brf-vps__count"></p><div class="brf-vps__grid" role="list"></div></div>'
          + '<div class="brf-vps__tray" hidden aria-live="polite"><span class="brf-vps__stack" aria-hidden="true"></span><span class="brf-vps__sum"><b></b><small></small></span><button type="button" class="brf-vps__add"></button></div></div>';
        document.body.appendChild(sheet);
        sheet.addEventListener('click', function(e){
          if (e.target.closest('[data-x]')) { closeSheet(); return; }
          var chip = e.target.closest('.brf-vps__chip');
          if (chip) {
            if (chip.hasAttribute('data-stock')) { filt.stock = !filt.stock; chip.classList.toggle('is-on', filt.stock); }
            else { var c = chip.getAttribute('data-c'); filt.colour = filt.colour === c ? null : c; [].forEach.call(sheet.querySelectorAll('.brf-vps__chip[data-c]'), function(x){ x.classList.toggle('is-on', x.getAttribute('data-c') === filt.colour); }); }
            drawGrid(); return;
          }
          if (e.target.closest('.brf-vps__q-n')) return;
          var qb = e.target.closest('[data-q]');
          if (qb) { if (Date.now() < holdSwallow) return; var cell = qb.closest('.brf-vps__cell'); step(parseInt(cell.getAttribute('data-i'), 10), parseInt(qb.getAttribute('data-q'), 10), cell); return; }
          if (e.target.closest('[data-clear]')) { picks = {}; drawGrid(); drawTray(); return; }
          if (e.target.closest('.brf-vps__add')) { addAll(); return; }
          var card = e.target.closest('.brf-vps__card');
          if (card) { var v = values[parseInt(card.getAttribute('data-i'), 10)]; choose(v); setTimeout(closeSheet, 120); }
        });
        sheet.querySelector('input').addEventListener('input', function(e){ filt.q = e.target.value.trim().toLowerCase(); drawGrid(); });
        /* typing a number in a design's qty box */
        sheet.addEventListener('input', function(e){
          var box = e.target.closest && e.target.closest('.brf-vps__q-n'); if (!box) return;
          var clean = box.value.replace(/\D+/g, '').slice(0, 2); if (clean !== box.value) box.value = clean;
          if (clean === '') return;
          var cell = box.closest('.brf-vps__cell'); setQ(parseInt(cell.getAttribute('data-i'), 10), parseInt(clean, 10), cell, false, true);
        });
        sheet.addEventListener('focusout', function(e){
          var box = e.target.closest && e.target.closest('.brf-vps__q-n'); if (!box) return;
          var cell = box.closest('.brf-vps__cell'), i = parseInt(cell.getAttribute('data-i'), 10);
          box.value = picks[i] || 0; cell.classList.toggle('has-q', !!picks[i]);
        });
        sheet.addEventListener('focusin', function(e){ var box = e.target.closest && e.target.closest('.brf-vps__q-n'); if (box) setTimeout(function(){ try { box.select(); } catch (x) {} }, 0); });
        sheet.addEventListener('keydown', function(e){
          var box = e.target.closest && e.target.closest('.brf-vps__q-n'); if (!box) return;
          if (e.key === 'Enter') { e.preventDefault(); box.blur(); }
          else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); var c = box.closest('.brf-vps__cell'); step(parseInt(c.getAttribute('data-i'), 10), e.key === 'ArrowUp' ? 1 : -1, c, true); box.value = picks[parseInt(c.getAttribute('data-i'), 10)] || 0; }
        });
        /* press and hold − or + to go faster, like the product page qty box */
        var hold = null, holdSwallow = 0;
        function holdStop(){ if (!hold) return; clearTimeout(hold.t); if (hold.n) holdSwallow = Date.now() + 450; hold = null; }
        sheet.addEventListener('pointerdown', function(e){
          var b = e.target.closest && e.target.closest('[data-q]'); if (!b || b.disabled || (e.button && e.button !== 0)) return;
          holdStop();
          var cell = b.closest('.brf-vps__cell'), i = parseInt(cell.getAttribute('data-i'), 10), d = parseInt(b.getAttribute('data-q'), 10);
          hold = {n: 0, t: 0};
          (function tick(first){
            hold.t = setTimeout(function(){
              if (!hold) return;
              var more = step(i, d, cell, true); hold.n++;
              if (!more || (d < 0 && !picks[i])) { holdStop(); return; }
              tick(false);
            }, first ? 420 : Math.max(45, 150 - hold.n * 10));
          })(true);
        });
        ['pointerup', 'pointercancel', 'pointerleave'].forEach(function(t){ sheet.addEventListener(t, function(e){ if (t !== 'pointerleave' || (e.target.closest && e.target.closest('[data-q]'))) holdStop(); }, true); });
        sheet.addEventListener('contextmenu', function(e){ if (e.target.closest && e.target.closest('[data-q]')) e.preventDefault(); });
        document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); });
      }
      function drawGrid(){
        var s = selected(), words = filt.q ? filt.q.split(/\s+/) : [];
        var shown = values.map(function(v, i){ return [v, i]; }).filter(function(p){
          var v = p[0], n = v.value.toLowerCase();
          if (filt.stock && !v.avail) return false;
          if (filt.colour && !v.colours.some(function(c){ return c[0] === filt.colour; })) return false;
          return words.every(function(w){ return n.indexOf(w) > -1; });
        });
        sheet.querySelector('.brf-vps__count').textContent = 'Showing ' + shown.length + ' of ' + values.length;
        var grid = sheet.querySelector('.brf-vps__grid');
        grid.innerHTML = shown.length ? shown.map(function(p){
          var v = p[0];
          var price = v.price === null ? '' : (v.cmp && v.cmp > v.price ? '<em>' + money(v.price) + '</em> <s>' + money(v.cmp) + '</s>' : money(v.price));
          var q = picks[p[1]] || 0, vr = variantFor(v), room = roomFor(vr);
          var ctl = room > 0 || q > 0 ? '<span class="brf-vps__ov"><span class="brf-vps__tip"></span><span class="brf-vps__q"><button type="button" class="brf-vps__q-m" data-q="-1" aria-label="One fewer ' + esc(v.value) + '">' + MINUS + '</button><input class="brf-vps__q-n" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="2" autocomplete="off" value="' + q + '" aria-label="How many ' + esc(v.value) + '"><button type="button" class="brf-vps__q-p" data-q="1" aria-label="Add ' + esc(v.value) + ' to your picks"' + (q >= room ? ' disabled' : '') + '>' + PLUS + '</button></span></span>' : '';
          return '<div role="listitem" class="brf-vps__cell' + (q ? ' has-q' : '') + '" data-i="' + p[1] + '"><button type="button" class="brf-vps__card' + (v === s ? ' is-on' : '') + (v.avail ? '' : ' is-out') + '" data-i="' + p[1] + '"><span class="brf-vps__img">' + thumbHtml(v, 300) + (v.img ? '' : '<span class="brf-vps__noimg">Photo coming soon</span>') + '</span><span class="brf-vps__name">' + esc(v.value) + '</span><span class="brf-vps__price">' + (v.avail ? price : 'Sold out') + '</span></button>' + ctl + '</div>';
        }).join('') : '<p class="brf-vps__empty">No designs match – try a different word or colour.</p>';
      }

      /* ---------- 4. Pick several ---------- */
      function pickList(){
        return Object.keys(picks).map(function(i){ var v = values[i]; return {i: +i, val: v, variant: variantFor(v), q: picks[i]}; }).filter(function(p){ return p.q > 0 && p.variant; });
      }
      function clampPicks(){
        Object.keys(picks).forEach(function(i){ var r = roomFor(variantFor(values[i])); if (picks[i] > r) picks[i] = r; if (!picks[i]) delete picks[i]; });
      }
      function tip(cell, msg){
        var t = cell && cell.querySelector('.brf-vps__tip'); if (!t) return;
        t.textContent = msg; t.classList.add('is-in'); clearTimeout(t.__t); t.__t = setTimeout(function(){ t.classList.remove('is-in'); }, 2200);
      }
      function step(i, d, cell, quiet){
        var v = values[i], vr = variantFor(v), room = roomFor(vr), q = (picks[i] || 0) + d;
        if (d > 0 && q > room) { tip(cell, room ? 'That’s every last one we’ve got! 🧵' : 'All of these are already in your bag 🧵'); return false; }
        return setQ(i, Math.max(0, q), cell, d > 0, quiet);
      }
      /* 2026-10-30 (Abid): shoppers can also type how many they want in the box (capped at what we have, minus the bag) */
      function setQ(i, q, cell, up, quiet){
        var v = values[i], room = roomFor(variantFor(v));
        if (q > room) { q = room; tip(cell, room ? 'We’ve only got ' + room + ' of these, so that’s the most you can pick 🧵' : 'All of these are already in your bag 🧵'); up = false; }
        if (q) picks[i] = q; else delete picks[i];
        var box = cell.querySelector('.brf-vps__q-n'), typing = box && document.activeElement === box;
        cell.classList.toggle('has-q', q > 0 || typing);
        if (box && (!typing || (String(q) !== box.value && box.value !== ''))) box.value = q;
        cell.querySelector('.brf-vps__q-p').disabled = q >= room;
        if (!quiet) { var pill = cell.querySelector('.brf-vps__q'); pill.classList.remove('is-pop'); void pill.offsetWidth; pill.classList.add('is-pop'); }
        if (up && q === room && room < 99) tip(cell, 'That’s the last ' + (room === 1 ? 'one' : room) + ' – grab ' + (room === 1 ? 'it' : 'them') + ' while you can!');
        drawTray();
        return q < room || !up;
      }
      function drawTray(err){
        var tray = sheet.querySelector('.brf-vps__tray'), list = pickList();
        var wasHidden = tray.hidden;
        if (!list.length && !err) { tray.hidden = true; return; }
        tray.hidden = false;
        if (wasHidden) { tray.classList.remove('is-in'); void tray.offsetWidth; tray.classList.add('is-in'); }
        var n = 0, total = 0;
        list.forEach(function(p){ n += p.q; total += p.q * p.variant.price; });
        var thumbs = list.slice(0, 4).map(function(p){ return '<span>' + thumbHtml(p.val, 100) + '</span>'; }).join('') + (list.length > 4 ? '<span><b>+' + (list.length - 4) + '</b></span>' : '');
        tray.querySelector('.brf-vps__stack').innerHTML = thumbs;
        tray.querySelector('.brf-vps__sum b').textContent = list.length + (list.length === 1 ? ' design' : ' designs') + ' · ' + money(total);
        tray.querySelector('.brf-vps__sum small').innerHTML = list.length ? esc(list.map(function(p){ return p.val.value + (p.q > 1 ? ' ×' + p.q : ''); }).join(', ')) + ' · <button type="button" data-clear>Clear</button>' : '';
        var add = tray.querySelector('.brf-vps__add');
        if (!add.classList.contains('is-done')) add.textContent = n ? 'Add ' + n + ' to bag' : 'Add to bag';
        add.disabled = !n;
        var e = tray.querySelector('.brf-vps__err'); if (e) e.remove();
        if (err) tray.insertAdjacentHTML('beforeend', '<p class="brf-vps__err" role="alert">' + err + '</p>');
      }
      function post(items){
        return fetch('/cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify({items: items})})
          .then(function(r){ return r.json().then(function(j){ return {ok: r.ok, j: j}; }, function(){ return {ok: r.ok, j: {}}; }); });
      }
      function addAll(){
        var list = pickList(), add = sheet.querySelector('.brf-vps__add');
        if (!list.length || add.getAttribute('aria-busy') === 'true') return;
        add.setAttribute('aria-busy', 'true'); add.textContent = 'Adding…';
        var items = list.map(function(p){ return {id: p.variant.id, quantity: p.q}; });
        function done(added, failed){
          add.removeAttribute('aria-busy');
          added.forEach(function(p){ inBag[p.variant.id] = (inBag[p.variant.id] || 0) + p.q; delete picks[p.i]; });
          var n = added.reduce(function(a, p){ return a + p.q; }, 0);
          if (failed.length) {
            add.classList.remove('is-done'); drawGrid();
            drawTray((n ? n + ' went in your bag, but ' : '') + esc(failed.map(function(p){ return p.val.value; }).join(', ')) + ' couldn’t' + ' be added – ' + (failed.length === 1 ? 'it' : 'they') + ' may have just sold out. Take ' + (failed.length === 1 ? 'it' : 'them') + ' off or try again.');
            if (n) handOff(n);
            return;
          }
          add.classList.add('is-done'); add.textContent = 'Added to bag ✓';
          setTimeout(function(){ closeSheet(); add.classList.remove('is-done'); drawGrid(); drawTray(); handOff(n); }, 700);
        }
        post(items).then(function(res){
          if (res.ok) return done(list, []);
          /* one line failed (usually stock): add them one at a time so the rest still go in */
          var added = [], failed = [];
          return list.reduce(function(chain, p){
            return chain.then(function(){ return post([{id: p.variant.id, quantity: p.q}]).then(function(r){ if (r.ok) added.push(p); else { p.why = (r.j && (r.j.description || r.j.message)) || ''; failed.push(p); } }); });
          }, Promise.resolve()).then(function(){ done(added, failed); });
        }).catch(function(){ add.removeAttribute('aria-busy'); drawTray('That didn’t go in. Please check your connection and try again.'); });
      }
      /* the bag icon, peek, toast, phone "Added to bag" label and Add to bag bar all listen for this */
      function handOff(n){
        var f = form() || document.body;
        f.dispatchEvent(new CustomEvent('product:added', {bubbles: true, detail: {variant: null, quantity: n}}));
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(init, 800);
  /* Warehouse 7 redraws the variant picker when the choice changes: set the picker up again on the new markup */
  if (window.MutationObserver) { var brfT; new MutationObserver(function(){ clearTimeout(brfT); brfT = setTimeout(init, 60); }).observe(document.documentElement, {childList: true, subtree: true}); }
})();
